/**
 * tdesign v0.21.1
 * (c) 2022 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-0b4c3c44.mjs';
import { defineComponent, ref, computed, createVNode } from 'vue';
import { TimeFilledIcon, CheckCircleFilledIcon, ErrorCircleFilledIcon, DeleteIcon, BrowseIcon } from 'tdesign-icons-vue-next';
import { Button } from '../button/index.mjs';
import { Loading } from '../loading/index.mjs';
import props from './props.mjs';
import { abridgeName, returnFileSize } from './util.mjs';
import { useTNodeJSX } from '../hooks/tnode.mjs';
import { useFormDisabled } from '../form/hooks.mjs';
import { usePrefixClass, useCommonClassName } from '../hooks/useConfig.mjs';
import { useGlobalIcon } from '../hooks/useGlobalIcon.mjs';
import { useConfig } from '../config-provider/useConfig.mjs';
import '../button/button.mjs';
import '../_chunks/dep-8c39d78a.mjs';
import '../_chunks/dep-556a2f2c.mjs';
import '../button/props.mjs';
import '../hooks/useRipple.mjs';
import '../hooks/useKeepAnimation.mjs';
import '../_chunks/dep-bfb23a5e.mjs';
import '../_chunks/dep-a48de419.mjs';
import '../_chunks/dep-2a7dc5c7.mjs';
import '../_chunks/dep-9311bf66.mjs';
import '../_chunks/dep-4889eb51.mjs';
import '../_chunks/dep-0b4185fe.mjs';
import '../_chunks/dep-3ca5fb38.mjs';
import '../_chunks/dep-7071345f.mjs';
import '../_chunks/dep-d2403b2f.mjs';
import '../_chunks/dep-7922050a.mjs';
import '../_chunks/dep-169ea640.mjs';
import '../_chunks/dep-f6b25712.mjs';
import '../_chunks/dep-59545a4d.mjs';
import '../_chunks/dep-c27b1c14.mjs';
import '../_chunks/dep-7d96367f.mjs';
import '../_chunks/dep-827c4600.mjs';
import '../_chunks/dep-0820e0e2.mjs';
import '../_chunks/dep-caad2e91.mjs';
import '../_chunks/dep-3d4aad09.mjs';
import '../_chunks/dep-8e38f523.mjs';
import '../_chunks/dep-469bf54b.mjs';
import '../_chunks/dep-8ef9fb8e.mjs';
import '../_chunks/dep-e769aafd.mjs';
import '../_chunks/dep-400798c5.mjs';
import '../_chunks/dep-361522ee.mjs';
import '../_common/js/global-config/default-config.mjs';
import '../_common/js/global-config/locale/zh_CN.mjs';
import '../utils/set-style.mjs';
import '../config-provider/type.mjs';
import '../loading/directive.mjs';
import '../loading/plugin.mjs';
import '../loading/loading.mjs';
import '../_chunks/dep-dcf624da.mjs';
import '../loading/icon/gradient.mjs';
import '../_common/js/loading/circle-adapter.mjs';
import '../_common/js/utils/set-style.mjs';
import '../_common/js/utils/helper.mjs';
import '../_chunks/dep-e68fd68c.mjs';
import '../utils/dom.mjs';
import '../_chunks/dep-2684fd15.mjs';
import '../utils/easing.mjs';
import '../utils/render-tnode.mjs';
import '../_chunks/dep-40522c7c.mjs';
import '../_chunks/dep-83862ee1.mjs';
import '../_chunks/dep-8e451077.mjs';
import '../_chunks/dep-a82b01df.mjs';
import '../_chunks/dep-192e10f1.mjs';
import '../_chunks/dep-977c5cdd.mjs';
import '../_chunks/dep-755716aa.mjs';
import '../_chunks/dep-82798823.mjs';
import '../_chunks/dep-52cbb58a.mjs';
import '../_chunks/dep-db11154e.mjs';
import '../_chunks/dep-baa4f9dc.mjs';
import '../utils/transfer-dom.mjs';
import '../loading/props.mjs';
import '../utils/withInstall.mjs';
import './style/css.mjs';
import '../loading/type.mjs';
import '../button/type.mjs';

var FlowList = defineComponent({
  name: "TUploadFlowList",
  props: {
    showUploadProgress: props.showUploadProgress,
    allowUploadDuplicateFile: props.allowUploadDuplicateFile,
    placeholder: props.placeholder,
    autoUpload: props.autoUpload,
    disabled: props.disabled,
    theme: props.theme,
    batchUpload: props.isBatchUpload,
    files: props.files,
    toUploadFiles: Array,
    onRemove: Function,
    onUpload: Function,
    onCancel: Function,
    onChange: Function,
    onDragleave: Function,
    onDragenter: Function,
    onImgPreview: Function,
    locale: {
      type: Object,
      "default": function _default() {
        return null;
      }
    }
  },
  setup: function setup(props2) {
    var target = ref(null);
    var dragActive = ref(false);
    var renderTNodeJSX = useTNodeJSX();
    var disabled = useFormDisabled();

    var _useConfig = useConfig("upload"),
        prefix = _useConfig.classPrefix,
        globalConfig = _useConfig.globalConfig;

    var _useGlobalIcon = useGlobalIcon({
      TimeFilledIcon: TimeFilledIcon,
      CheckCircleFilledIcon: CheckCircleFilledIcon,
      ErrorCircleFilledIcon: ErrorCircleFilledIcon,
      DeleteIcon: DeleteIcon,
      BrowseIcon: BrowseIcon
    }),
        TimeFilledIcon$1 = _useGlobalIcon.TimeFilledIcon,
        CheckCircleFilledIcon$1 = _useGlobalIcon.CheckCircleFilledIcon,
        ErrorCircleFilledIcon$1 = _useGlobalIcon.ErrorCircleFilledIcon,
        DeleteIcon$1 = _useGlobalIcon.DeleteIcon,
        BrowseIcon$1 = _useGlobalIcon.BrowseIcon;

    var UPLOAD_NAME = usePrefixClass("upload");

    var _useCommonClassName = useCommonClassName(),
        SIZE = _useCommonClassName.SIZE;

    var waitingUploadFiles = computed(function () {
      var list = [];
      props2.toUploadFiles.forEach(function (item) {
        if (!props2.allowUploadDuplicateFile) {
          var r = props2.files.filter(function (t) {
            return t.name === item.name;
          });

          if (!r.length) {
            list.push(item);
          }
        } else {
          list.push(item);
        }
      });
      return list;
    });
    var showInitial = computed(function () {
      var isWaitingEmpty = !waitingUploadFiles.value || !waitingUploadFiles.value.length;
      return (!props2.files || !props2.files.length) && isWaitingEmpty;
    });
    var listFiles = computed(function () {
      if (!props2.files || !props2.files.length) return props2.toUploadFiles;
      return props2.files.concat(waitingUploadFiles.value);
    });
    var failedList = computed(function () {
      return props2.toUploadFiles.filter(function (file) {
        return file.status === "fail";
      });
    });
    var processList = computed(function () {
      return props2.toUploadFiles.filter(function (file) {
        return file.status === "progress";
      });
    });
    var isUploading = computed(function () {
      return !!processList.value.length;
    });
    var allowUpload = computed(function () {
      return Boolean(waitingUploadFiles.value && waitingUploadFiles.value.length) && !isUploading.value;
    });
    var uploadText = computed(function () {
      var _localeFromProps$trig, _localeFromProps$trig2;

      var localeFromProps = props2.locale;
      if (isUploading.value) return "".concat(globalConfig.value.progress.uploadingText, "...");
      return failedList.value && failedList.value.length ? (localeFromProps === null || localeFromProps === void 0 ? void 0 : (_localeFromProps$trig = localeFromProps.triggerUploadText) === null || _localeFromProps$trig === void 0 ? void 0 : _localeFromProps$trig.reupload) || globalConfig.value.triggerUploadText.reupload : (localeFromProps === null || localeFromProps === void 0 ? void 0 : (_localeFromProps$trig2 = localeFromProps.triggerUploadText) === null || _localeFromProps$trig2 === void 0 ? void 0 : _localeFromProps$trig2.normal) || globalConfig.value.triggerUploadText.normal;
    });

    var handleDrop = function handleDrop(event) {
      event.preventDefault();
      props2.onChange(event.dataTransfer.files);
      props2.onDragleave(event);
      dragActive.value = false;
    };

    var handleDragenter = function handleDragenter(event) {
      target.value = event.target;
      event.preventDefault();
      props2.onDragenter(event);
      dragActive.value = true;
    };

    var handleDragleave = function handleDragleave(event) {
      if (target.value !== event.target) return;
      event.preventDefault();
      props2.onDragleave(event);
      dragActive.value = false;
    };

    var handleDragover = function handleDragover(event) {
      event.preventDefault();
    };

    var renderDragger = function renderDragger() {
      return createVNode("div", {
        "class": "".concat(UPLOAD_NAME.value, "__flow-empty"),
        "onDrop": handleDrop,
        "onDragenter": handleDragenter,
        "onDragover": handleDragover,
        "onDragleave": handleDragleave
      }, [dragActive.value ? globalConfig.value.dragger.dragDropText : globalConfig.value.dragger.clickAndDragText]);
    };

    var getStatusMap = function getStatusMap(file) {
      var _props2$locale;

      var localeProgressFromProps = (_props2$locale = props2.locale) === null || _props2$locale === void 0 ? void 0 : _props2$locale.progress;
      var iconMap = {
        success: createVNode(CheckCircleFilledIcon$1, null, null),
        fail: createVNode(ErrorCircleFilledIcon$1, null, null),
        progress: createVNode(Loading, null, null),
        waiting: createVNode(TimeFilledIcon$1, null, null)
      };
      var textMap = {
        success: (localeProgressFromProps === null || localeProgressFromProps === void 0 ? void 0 : localeProgressFromProps.successText) || globalConfig.value.progress.successText,
        fail: (localeProgressFromProps === null || localeProgressFromProps === void 0 ? void 0 : localeProgressFromProps.failText) || globalConfig.value.progress.failText,
        progress: "".concat((localeProgressFromProps === null || localeProgressFromProps === void 0 ? void 0 : localeProgressFromProps.uploadingText) || globalConfig.value.progress.uploadingText, " ").concat(Math.min(file.percent, 99), "%"),
        waiting: (localeProgressFromProps === null || localeProgressFromProps === void 0 ? void 0 : localeProgressFromProps.waitingText) || globalConfig.value.progress.waitingText
      };
      return {
        iconMap: iconMap,
        textMap: textMap
      };
    };

    var renderStatus = function renderStatus(file) {
      if (!props2.showUploadProgress) return;

      var _getStatusMap = getStatusMap(file),
          iconMap = _getStatusMap.iconMap,
          textMap = _getStatusMap.textMap;

      return createVNode("div", {
        "class": "".concat(UPLOAD_NAME.value, "__flow-status")
      }, [iconMap[file.status], createVNode("span", null, [textMap[file.status]])]);
    };

    var renderNormalActionCol = function renderNormalActionCol(file, index) {
      var _props2$locale2, _props2$locale2$trigg;

      return createVNode("td", null, [createVNode("span", {
        "class": "".concat(UPLOAD_NAME.value, "__flow-button"),
        "onClick": function onClick(e) {
          return props2.onRemove({
            e: e,
            index: index,
            file: file
          });
        }
      }, [((_props2$locale2 = props2.locale) === null || _props2$locale2 === void 0 ? void 0 : (_props2$locale2$trigg = _props2$locale2.triggerUploadText) === null || _props2$locale2$trigg === void 0 ? void 0 : _props2$locale2$trigg["delete"]) || globalConfig.value.triggerUploadText["delete"]])]);
    };

    var renderBatchActionCol = function renderBatchActionCol(index) {
      var _props2$locale3, _props2$locale3$trigg;

      return index === 0 ? createVNode("td", {
        "rowspan": listFiles.value.length,
        "class": "".concat(UPLOAD_NAME.value, "__flow-table__batch-row")
      }, [createVNode("span", {
        "class": "".concat(UPLOAD_NAME.value, "__flow-button"),
        "onClick": function onClick(e) {
          return props2.onRemove({
            e: e,
            index: -1,
            file: null
          });
        }
      }, [((_props2$locale3 = props2.locale) === null || _props2$locale3 === void 0 ? void 0 : (_props2$locale3$trigg = _props2$locale3.triggerUploadText) === null || _props2$locale3$trigg === void 0 ? void 0 : _props2$locale3$trigg["delete"]) || globalConfig.value.triggerUploadText["delete"]])]) : "";
    };

    var renderFileList = function renderFileList() {
      var _props2$locale4, _props2$locale4$file, _props2$locale5, _props2$locale5$file, _props2$locale6, _props2$locale6$file, _props2$locale7, _props2$locale7$file;

      return props2.theme === "file-flow" && createVNode("table", {
        "class": "".concat(UPLOAD_NAME.value, "__flow-table")
      }, [createVNode("tr", null, [createVNode("th", null, [((_props2$locale4 = props2.locale) === null || _props2$locale4 === void 0 ? void 0 : (_props2$locale4$file = _props2$locale4.file) === null || _props2$locale4$file === void 0 ? void 0 : _props2$locale4$file.fileNameText) || globalConfig.value.file.fileNameText]), createVNode("th", null, [((_props2$locale5 = props2.locale) === null || _props2$locale5 === void 0 ? void 0 : (_props2$locale5$file = _props2$locale5.file) === null || _props2$locale5$file === void 0 ? void 0 : _props2$locale5$file.fileSizeText) || globalConfig.value.file.fileSizeText]), createVNode("th", null, [((_props2$locale6 = props2.locale) === null || _props2$locale6 === void 0 ? void 0 : (_props2$locale6$file = _props2$locale6.file) === null || _props2$locale6$file === void 0 ? void 0 : _props2$locale6$file.fileStatusText) || globalConfig.value.file.fileStatusText]), createVNode("th", null, [((_props2$locale7 = props2.locale) === null || _props2$locale7 === void 0 ? void 0 : (_props2$locale7$file = _props2$locale7.file) === null || _props2$locale7$file === void 0 ? void 0 : _props2$locale7$file.fileOperationText) || globalConfig.value.file.fileOperationText])]), showInitial.value && createVNode("tr", null, [createVNode("td", {
        "colspan": 4
      }, [renderDragger()])]), listFiles.value.map(function (file, index) {
        var showBatchUploadAction = props2.batchUpload && props2.toUploadFiles.length === 0;
        return createVNode("tr", null, [createVNode("td", null, [abridgeName(file.name, 7, 10)]), createVNode("td", null, [returnFileSize(file.size)]), createVNode("td", null, [renderStatus(file)]), showBatchUploadAction ? renderBatchActionCol(index) : renderNormalActionCol(file, index)]);
      })]);
    };

    var renderImgItem = function renderImgItem(file, index) {
      var _getStatusMap2 = getStatusMap(file),
          iconMap = _getStatusMap2.iconMap,
          textMap = _getStatusMap2.textMap;

      return createVNode("li", {
        "class": "".concat(UPLOAD_NAME.value, "__card-item")
      }, [createVNode("div", {
        "class": ["".concat(UPLOAD_NAME.value, "__card-content"), _defineProperty({}, "".concat(prefix.value, "-is-bordered"), file.status !== "waiting")]
      }, [["fail", "progress"].includes(file.status) && createVNode("div", {
        "class": "".concat(UPLOAD_NAME.value, "__card-status-wrap")
      }, [iconMap[file.status], createVNode("p", null, [textMap[file.status]])]), (["waiting", "success"].includes(file.status) || !file.status && file.url) && createVNode("img", {
        "class": "".concat(UPLOAD_NAME.value, "__card-image"),
        "src": file.url || "//tdesign.gtimg.com/tdesign-default-img.png"
      }, null), createVNode("div", {
        "class": "".concat(UPLOAD_NAME.value, "__card-mask")
      }, [file.url && createVNode("span", {
        "class": "".concat(UPLOAD_NAME.value, "__card-mask-item")
      }, [createVNode(BrowseIcon$1, {
        "onClick": function onClick(_ref2) {
          var e = _ref2.e;
          return props2.onImgPreview(e, file);
        }
      }, null), createVNode("span", {
        "class": "".concat(UPLOAD_NAME.value, "__card-mask-item-divider")
      }, null)]), !disabled.value && createVNode("span", {
        "class": "".concat(UPLOAD_NAME.value, "__card-mask-item"),
        "onClick": function onClick(e) {
          return props2.onRemove({
            e: e,
            index: index,
            file: file
          });
        }
      }, [createVNode(DeleteIcon$1, null, null)])])]), createVNode("p", {
        "class": "".concat(UPLOAD_NAME.value, "__card-name")
      }, [abridgeName(file.name)])]);
    };

    var renderImgList = function renderImgList() {
      return props2.theme === "image-flow" && createVNode("div", {
        "class": "".concat(UPLOAD_NAME.value, "__flow-card-area"),
        "onDrop": handleDrop,
        "onDragenter": handleDragenter,
        "onDragover": handleDragover,
        "onDragleave": handleDragleave
      }, [showInitial.value && renderDragger(), !!listFiles.value.length && createVNode("ul", {
        "class": "".concat(UPLOAD_NAME.value, "__card clearfix")
      }, [listFiles.value.map(function (file, index) {
        return renderImgItem(file, index);
      })])]);
    };

    var renderFooter = function renderFooter() {
      var _props2$locale8;

      return !props2.autoUpload && createVNode("div", {
        "class": "".concat(UPLOAD_NAME.value, "__flow-bottom")
      }, [createVNode(Button, {
        "theme": "default",
        "onClick": props2.onCancel,
        "disabled": !allowUpload.value
      }, {
        "default": function _default() {
          return [((_props2$locale8 = props2.locale) === null || _props2$locale8 === void 0 ? void 0 : _props2$locale8.cancelUploadText) || globalConfig.value.cancelUploadText];
        }
      }), createVNode(Button, {
        "disabled": !allowUpload.value,
        "theme": "primary",
        "onClick": function onClick(e) {
          return props2.onUpload(waitingUploadFiles.value, e);
        }
      }, {
        "default": function _default() {
          return [uploadText.value];
        }
      })]);
    };

    return function () {
      return createVNode("div", {
        "class": ["".concat(UPLOAD_NAME.value, "__flow"), "".concat(UPLOAD_NAME.value, "__flow-").concat(props2.theme)]
      }, [createVNode("div", {
        "class": "".concat(UPLOAD_NAME.value, "__flow-op")
      }, [renderTNodeJSX("default"), createVNode("small", {
        "class": "".concat(SIZE.value.small, " ").concat(UPLOAD_NAME.value, "__flow-placeholder")
      }, [props2.placeholder])]), renderFileList(), renderImgList(), renderFooter()]);
    };
  }
});

export { FlowList as default };
//# sourceMappingURL=flow-list.mjs.map
